import { Dispatch } from "redux";
import { Action, ActionType } from "../../actions";
import PushbackService from "../../../services/pushbackService";
import { IPushbackLoans } from "../../../models/configuration/pushback/IPushbackLoans";

const getPushbackLoansData = (configId: string, token: string | null, datetimeoffset: string):
    (dispatch: Dispatch<Action>, getState: () => any) => Promise<void> => {
    return async (dispatch: Dispatch<Action>) => {

        // Parse date and set time to noon to avoid timezone issues
        const date = new Date(datetimeoffset);
        if (isNaN(date.getTime())) {
            throw new Error("Invalid DateTime Provided");
        }
        
        // Set time to noon to avoid timezone edge cases
        date.setHours(12, 0, 0, 0);

        dispatch({ type: ActionType.GET_PUSHBACK_LOANS });

        try {
            const payload = await new PushbackService().getOrderDetailLoans<IPushbackLoans>(token, configId, date);

            dispatch({
                type: ActionType.GET_PUSHBACK_LOANS_SUCCESS,
                payload: payload,
            });

        } catch (error: any) {

            console.error("Get Pushback loans data");
            if (error instanceof Error) {
                var payloadErrorMessage = `Failed to pushback loans data: (${error.message})`;
                dispatch({
                    type: ActionType.GET_PUSHBACK_LOANS_FAILURE,
                    payload: payloadErrorMessage,
                });
            }

        }
    }
}

export default getPushbackLoansData;